<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To</p>
<p style="text-align: center;">the memory of the Brothers Grimm</p>
<p style="text-align: center;">and to</p>
<p style="text-align: center;">the King’s Singers</p>
<p style="text-align: center;">who give an excellent rendering of the four friends’ voices.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7e347f1d